export default "__VITE_ASSET__C6zAG94M__"